import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { FormBuscarVeiculoV2 } from "../../Molecules/FormBuscarVeiculoV2";
import { Tracking } from "../../../services/Tracking";
import { useLicenseV2 } from "./useLicenseV2";

export const LicenseV2 = () => {
  const { stepIndicator, handleSubmit } = useLicenseV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/servicos/emplacamento:pageview");
  });

  return (
    <ContainerV2 nextButton={{ title: "Avançar", disabled: true }}>
      {stepIndicator}
      <H1 className="mb-4 mt-8">Identifique o veículo</H1>
      <P className="mb-6 text-[#666666]">
        Consultamos as informações automaticamente. Você só precisa confirmar.
      </P>

      <FormBuscarVeiculoV2 modo="chassi" onSubmitForm={handleSubmit} />
    </ContainerV2>
  );
};
